import { deleteApi, get, post } from "../../config/api";
 
class IotService {

    static async getMachineStructure(kitchenId) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/structure`;
        return await get({ url });
    }

    static async getKitchenSystemEvents(kitchenId) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/events`;
        return await get({ url }); 
    }

    static async getModuleTypeWiseDetails(kitchenId, moduleType) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/moduleType/${moduleType}/state`;
        return await get({ url }); 
    }

    static async getModuleTelemetries(kitchenId, moduleId) {
        moduleId = moduleId.replace(/\D/g, "");
        const url = `/v3/dashboard/kitchen/${kitchenId}/module/${moduleId}/telemetries`;
        return await get({ url }); 
    }

    static async sendWorkFlowRequest(kitchenId, data) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/`;
        return await post({ url, data }); 
    }

    static async sendTask(kitchenId, restaurantId, task, payload = {}) {
        const url = `/v1/dashboard/kitchen/${kitchenId}/systemTask`;
        return await post({ url, data : { taskType:task, taskData:payload, restaurantId } });
    }

    static async sendPrimeTask(kitchenId, restaurantId, payload = {}) {
        const url = `/v1/dashboard/kitchen/${kitchenId}/primeTask`;
        return await post({ url, data : { taskData:payload, restaurantId } });
    }

    static async getTaskStatus(kitchenId, taskId) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/task/status?taskGroupId=${taskId}`;
        return await get({ url });
    }

    static async getPeriodicAgitations(kitchenId) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/agitation/systems`;
        return await get({ url });
    }

    static async clearKitchen(kitchenId) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/clear`;
        return await post({ url });
    }

    static async resetKitchenState(kitchenId, key) {
        const url = `/v3/dashboard/kitchen/${kitchenId}/state/${key}`;
        return await deleteApi({ url });
    }

}

export default IotService;